import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { MILEAGE_METRIC } from 'constant'
import {
  VehicleNickname,
  EditIcon,
  MileageWrapper,
  MileageIcon,
  MileageValueWrapper,
  MileageValue,
  MileageEntity,
  VehicleYMME,
  VehicleImg,
  TrailerImage
} from 'components/MyGarage2.0/components/SharedStyles'
import { addCommas, isNicknamePersonalized, isNicknameDuplicate, withNicknameSufix } from 'components/MyGarage2.0/helpers'

const VehicleInfo = ({
  mileage,
  vehicleNickname,
  vehicleName,
  vehicleColor,
  masterVehicle: {
    makeDesc,
    modelDesc,
    subModelDesc,
    yearDesc
  } = {},
  formattedTireSize,
  isTrailer,
  isGenericTrailer,
  navigateToVehicleDetailsPage,
  openEditMileageModal
}) =>
  <>
    { isGenericTrailer ?
      <CustomVehicleNickname>
        { vehicleName }
      </CustomVehicleNickname> :
      <CustomVehicleNickname onClick={ navigateToVehicleDetailsPage }>
        { isNicknamePersonalized(vehicleName, vehicleNickname) ?
          vehicleNickname :
          isNicknameDuplicate(vehicleNickname) ? withNicknameSufix(vehicleNickname) : `${yearDesc} ${makeDesc}` }
      </CustomVehicleNickname>
    }
    { isTrailer &&
      <VehicleYMMEText>
        { formattedTireSize }
      </VehicleYMMEText>
    }
    { (!isTrailer && !isGenericTrailer) &&
      <VehicleYMMEText clickable onClick={ navigateToVehicleDetailsPage }>
        { isNicknamePersonalized(vehicleName, vehicleNickname) ? vehicleName : `${modelDesc} ${subModelDesc}` }
      </VehicleYMMEText>
    }
    { isTrailer || isGenericTrailer
      ? <TrailerImage asset="icon-trailer" alt={ 'Trailer' } />
      : (
        <CustomVehicleImg
          year={ parseInt(yearDesc, 10) }
          make={ makeDesc }
          model={ modelDesc }
          submodel={ subModelDesc }
          color={ vehicleColor ? `#${vehicleColor}` : undefined }
          height={ 115 }
          width={ 250 }
          onClick={ navigateToVehicleDetailsPage } />
      )
    }
    { (!isTrailer && !isGenericTrailer) &&
      <CustomMileageWrapper>
        <MileageIcon asset="speedometer-grey" />
        <MileageValueWrapper>
          <MileageValue>
            { addCommas(mileage) }
          </MileageValue>
          <MileageEntity>
            { MILEAGE_METRIC }
          </MileageEntity>
        </MileageValueWrapper>
        <EditIcon
          asset="edit-red"
          alt="Edit Vehicle Button"
          tabIndex="0"
          onClick={ openEditMileageModal } />
      </CustomMileageWrapper> }
  </>

export default VehicleInfo

VehicleInfo.propTypes = {
  formattedTireSize: PropTypes.string,
  isGenericTrailer: PropTypes.bool,
  isTrailer: PropTypes.bool,
  masterVehicle: PropTypes.shape({
    makeDesc: PropTypes.string,
    modelDesc: PropTypes.string,
    subModelDesc: PropTypes.string,
    yearDesc: PropTypes.string
  }),
  mileage: PropTypes.string,
  navigateToVehicleDetailsPage: PropTypes.func,
  openEditMileageModal: PropTypes.func,
  vehicleColor: PropTypes.string,
  vehicleName: PropTypes.string,
  vehicleNickname: PropTypes.string
}

const CustomVehicleNickname = styled(VehicleNickname)`
  margin-bottom: 13px;
  cursor: pointer;
`

const CustomMileageWrapper = styled(MileageWrapper)`
  margin-bottom: 35px;
`

const CustomVehicleImg = styled(VehicleImg)`
  cursor: pointer;
`

const VehicleYMMEText = styled(VehicleYMME)`
  ${props => props.clickable && css`
    cursor: pointer;
  `}
`
